
    import './styles.scoped.css';
    export default {
  "placeholder": "awsui_placeholder_dwuol_1hw90_141",
  "disabled": "awsui_disabled_dwuol_1hw90_146",
  "item": "awsui_item_dwuol_1hw90_150",
  "checkbox": "awsui_checkbox_dwuol_1hw90_154",
  "option-group": "awsui_option-group_dwuol_1hw90_163",
  "filter": "awsui_filter_dwuol_1hw90_167",
  "trigger": "awsui_trigger_dwuol_1hw90_172",
  "layout-strut": "awsui_layout-strut_dwuol_1hw90_178",
  "list-bottom": "awsui_list-bottom_dwuol_1hw90_184",
  "selected-icon": "awsui_selected-icon_dwuol_1hw90_188",
  "show-label-tag": "awsui_show-label-tag_dwuol_1hw90_193",
  "inline-token-trigger": "awsui_inline-token-trigger_dwuol_1hw90_197",
  "inline-token-list": "awsui_inline-token-list_dwuol_1hw90_204",
  "inline-token-hidden-placeholder": "awsui_inline-token-hidden-placeholder_dwuol_1hw90_218",
  "inline-token-counter": "awsui_inline-token-counter_dwuol_1hw90_224",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_dwuol_1hw90_228",
  "inline-label-wrapper": "awsui_inline-label-wrapper_dwuol_1hw90_232",
  "inline-label": "awsui_inline-label_dwuol_1hw90_228",
  "inline-label-disabled": "awsui_inline-label-disabled_dwuol_1hw90_257",
  "inline-label-inline-tokens": "awsui_inline-label-inline-tokens_dwuol_1hw90_261",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_dwuol_1hw90_266"
};
  